define('models/search/searchitem',["backbone"], function (Backbone) {

    var SearchItem = Backbone.Model.extend({

        initialize: function (options) {
            options = options || {};

            /* New Merchant Search Model */
            this.HideRebate = options.hide_rebate;
            this.Address = options.address;
            this.AggregatorID = options.aggregatorid;
            this.Category = options.category;
            this.City = options.city;
            this.Distance = options.distance;
            this.Location = options.location;
            this.LocID = options.locid;
            this.MerchantGroupGUID = options.mgguid;
            this.MerchantGUID = options.mguid;
            this.Name = options.name;
            this.Percent = options.percent;
            this.StateAbbreviation = options.stateabbreviation;
            this.Type = options.type;
            this.ZipCode = options.zip;
            this.Score = options._score;
            /* End New Merchant Search Model */

            // TODO: Merge the new with the old
            // this.AggregatorID = options.AGID;
            // this.Category = options.CT;
            // this.City = options.C;
            // this.Distance = options.DI;
            // this.MerchantGroupGUID = options.MGG;
            // this.Name = options.N;
            // this.StateAbbreviation = options.SA;
            // this.Type = options.T;
            // this.ZipCode = options.ZC;

            this.ID = options.I;
            this.GUID = options.GID;
            this.ManagedBy = options.MB;
            this.ManagerGUID = options.MBG;
            this.ShortDescription = options.SD;
            this.AddressLine1 = options.AL1;
            this.AddressLine2 = options.AL2;
            this.State = options.S;
            this.AccountTypeID = options.ATID;
            this.LocationCount = options.LC;
            switch (this.T) {
                case pf.enums.searchResultTypeEnum.User:
                    this.PhotoURL = buildImageURL(pf.enums.entityTypeCodeEnum.User, this.GID, pf.enums.imageTypeGUIDEnum.Thumbnail, options.PU);
                    this.LogoURL = buildImageURL(pf.enums.entityTypeCodeEnum.User, this.GID, pf.enums.imageTypeGUIDEnum.Thumbnail, options.LU);
                    break;
                case pf.enums.searchResultTypeEnum.Account:
                    this.PhotoURL = buildImageURL(pf.enums.entityTypeCodeEnum.Account, this.GID, pf.enums.imageTypeGUIDEnum.Thumbnail, options.PU);
                    this.LogoURL = buildImageURL(pf.enums.entityTypeCodeEnum.Account, this.GID, pf.enums.imageTypeGUIDEnum.Thumbnail, options.LU);
                    break;
                case pf.enums.searchResultTypeEnum.Merchant:
                    this.LogoURL = buildImageURL(pf.enums.entityTypeCodeEnum.Merchant, this.GID, pf.enums.imageTypeGUIDEnum.Thumbnail, options.LU);
                    break;
            };
            //this.ConnectionCount = options.CCN;
            //this.ManagingCount = options.MCN;
            //this.SupportingCount = options.SCN;
            this.Commission = options.COM;
            this.MinPercentage = options.MINC;
            this.MaxPercentage = options.MAXC;
            this.EmailForInvitation = options.EFI;
            this.MerchantGroupName = options.MGN;
            this.IsProfilePrivate = options.IUP;
            this.IsConnected = options.ISC;
            this.NPOName = options.NN;
          //  this.TagLine = options.TL;
            this.PhoneNumber = options.PN;
            this.IsParticipant = options.IP;
            this.CategoryID = options.CID;
            this.ConnectionStatusTypeID = options.CSTID;
            this.ParticipantStatusID = options.PSID;
            this.CurrentRebatePercentage = options.CRP;
            this.NextRebatePercentage = options.NRP;
            this.CurrentRebateIsPromo = options.CRIP;
            this.NextRebateIsPromo = options.NRIP;
            this.NextRebateTime = options.NRT;
            this.NextRebateDisplayTimeOnly = options.NRDTO;
            this.LocationTypeID = options.LTID;
            this.AffiliateUrl = options.AURL;
            this.PopularityIndex = options.PTI;
            this.CreatedDT = Date.parse(options.CDT);
        },

        parse: function (data) {
            var response = {};

            /* New Merchant Search Model */
            response.HideRebate = data.hide_rebate;
            response.Address = data.address;
            response.Location = data.location;
            response.LocID = data.locid;
            response.MerchantGUID = data.mguid;
            response.Logo = buildImageURL(pf.enums.entityTypeCodeEnum.Merchant, data.mgguid, pf.enums.imageTypeGUIDEnum.Profile320, data.logo);
            response.Percent = data.percent;
            response.Score = data._score;
            /* End New Merchant Search Model */

            /* New Merchant Search Model Merged With Old */
            response.GUID = (data.GID) ? data.GID : data.mguid;
            response.AggregatorID = (data.AGID) ? data.AGID : data.aggregatorid;
            response.Category = (data.CT) ? data.CT : data.category;
            response.City = (data.C) ? data.C : data.city;
            response.Distance = (data.DI) ? data.DI : data.distance;
            response.MerchantGroupGUID = (data.MGG) ? data.MGG : data.mgguid;
            response.Name = (data.N) ? data.N : data.name;
            response.StateAbbreviation = (data.SA) ? data.SA : data.stateabbreviation;
            response.Type = (data.T) ? data.T : data.type;
            response.ZipCode = (data.ZC) ? data.ZC : data.zip;
            response.AffiliateUrl = (data.AURL) ? data.AURL : data.aurl;
            response.State = (data.S) ? data.S : data.stateabbreviation;
            response.CurrentRebatePercentage = (data.CRP) ? data.CRP : data.percent;
            /* End New Merchant Search Model Merged With Old */

            response.ID = data.I;
            response.ManagedBy = data.MB;
            response.ManagerGUID = data.MBG;
            response.ShortDescription = data.SD;
            response.AddressLine1 = data.AL1;
            response.AddressLine2 = data.AL2;
            response.AccountTypeID = data.ATID;
            response.LocationCount = data.LC;
            response.Latitude = data.LAT;
            response.Longitude = data.LON;

            switch(data.T){
                case pf.enums.searchResultTypeEnum.User:
                    response.PhotoURL = buildImageURL(pf.enums.entityTypeCodeEnum.User, data.GID, pf.enums.imageTypeGUIDEnum.Profile320, data.PU);
                    response.LogoURL = buildImageURL(pf.enums.entityTypeCodeEnum.User, data.GID, pf.enums.imageTypeGUIDEnum.Profile320, data.LU);
                    break;
                case pf.enums.searchResultTypeEnum.Account:
                    response.PhotoURL = buildImageURL(pf.enums.entityTypeCodeEnum.Account, data.GID, pf.enums.imageTypeGUIDEnum.Profile320, data.PU);
                    response.LogoURL = buildImageURL(pf.enums.entityTypeCodeEnum.Account, data.GID, pf.enums.imageTypeGUIDEnum.Profile320, data.LU);
                    break;
                case pf.enums.searchResultTypeEnum.Merchant:
                    response.LogoURL = buildImageURL(pf.enums.entityTypeCodeEnum.Merchant, data.MGG, pf.enums.imageTypeGUIDEnum.Profile320, data.LU);
                    break;
            };
            
            //response.ConnectionCount = data.CCN;
            //response.ManagingCount = data.MCN;
            //response.SupportingCount = data.SCN
            response.Commission = data.COM;
            response.MinPercentage = data.MINC;
            response.MaxPercentage = data.MAXC;
            response.EmailForInvitation = data.EFI;
            response.MerchantGroupName = data.MGN;
            response.IsProfilePrivate = data.IUP;
            response.IsConnected = data.ISC;
            response.NPOName = data.NN;
          //  response.TagLine = data.TL;
            response.PhoneNumber = data.PN;
            response.IsParticipant = data.IP;
            response.CategoryID = data.CID;
            response.ConnectionStatusTypeID =data.CSTID;
            response.ParticipantStatusID = data.PSID;
            response.NextRebatePercentage = data.NRP;
            response.CurrentRebateIsPromo = data.CRIP;
            response.NextRebateIsPromo = data.NRIP;
            response.NextRebateTime = data.NRT;
            response.NextRebateDisplayTimeOnly = data.NRDTO;
            response.LocationTypeID = data.LTID;
            response.PopularityIndex = data.PTI;
            response.CreatedDT = Date.parse(data.CDT);
            //response.IsCurrentDealPromo = data.ICDP;
            //response.UpComingDeal = data.UPD;
            //response.UpComingDealStartDT = Date.parse(data.UPDST);
            //response.UpComingDealIsPromo = data.UPDIP;
            //response.UpComingDealShowTimeOnly = data.UPRST;


            return response;
        }
    });

    return SearchItem;
});

